// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-divider[data-v-5641996a] {\n  margin: 1.2em 0;\n}\ntfoot tr td[data-v-5641996a] {\n  padding-right: 20px !important;\n}", ""]);
// Exports
module.exports = exports;
